export default "/assets/31108767c4f945c8.png"